import { useQuery } from '@tanstack/react-query';
import type { LocalAgentSDK } from '@localagent/sdk';
import { sdkAtom, sdkConfiguredAtom } from '../stores/sdk/atoms';
import { store } from '../stores';

export function getSDK(): LocalAgentSDK {
  const sdk = store.get(sdkAtom);
  if (sdk === null) {
    throw new Error('SDK accessed before installation. Wait for the bootstrap to complete.');
  }
  return sdk;
}

/**
 * The device identity, asked of the SDK per call (sdk ADR-009 — the one place the question is answered). Never cached here: on the
 * daemon arm the id moves during register-and-adopt, and a cached value 404s
 * "Device not found" for the life of the window.
 */
export async function getDeviceIdAsync(): Promise<string> {
  return getSDK().deviceId();
}

/**
 * The synchronous React-Query-key form of the identity. The VALUE is asked of
 * the SDK per fetch — a key is cache identity, never the wire value, so this
 * snapshot does not reintroduce the pinning the async paths removed.
 */
export function useDeviceId(): string | null {
  const configured = store.get(sdkConfiguredAtom);
  const { data } = useQuery({
    queryKey: ['device-identity'],
    queryFn: async () => getDeviceIdAsync(),
    enabled: configured,
    staleTime: Infinity,
    retry: 2,
  });
  return data ?? null;
}
